import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchPosts = createAsyncThunk("posts/fetchPosts", async () => {
  const response = await apiCustom.get("/posts");
  return response.data?.data?.data?.map((post) => ({
    ...post,
    imageUrl: post?.images?.[0]?.url,
  }));
});

export const fetchNotifications = createAsyncThunk(
  "posts/notification",
  async () => {
    const response = await apiCustom.get("/posts?type=notification");
    return response.data?.data?.data;
  }
);
export const fetchPublicPosts = createAsyncThunk(
  "posts/fetchPublicPosts",
  async () => {
    const response = await apiCustom.get("/posts-public");
    return response.data?.data?.data;
  }
);
export const savePost = createAsyncThunk(
  "posts/savePost",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/blog-posts-create", newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updatePost = createAsyncThunk(
  "posts/updatePost",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/posts-update/${id}`, newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const approvePost = createAsyncThunk(
  "posts/approvePost",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/posts-approve/${id}`, newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deletePost = createAsyncThunk(
  "posts/deletePost",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/posts-delete/${id}`);
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
const postsSlice = createSlice({
  name: "posts",
  initialState: {
    posts: [],
    authPosts: [],
    authNotifications: [],
    status: "idle",
    authPostStatus: "idle",
    authNotificationStatus: "idle",
    error: null,
    authPostError: null,
    authNotificationError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.authPostStatus = "loading";
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.authPostStatus = "succeeded";
        state.authPosts = action.payload;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.authPostStatus = "failed";
        state.authPostError = action.payload;
      })

      .addCase(fetchNotifications.pending, (state) => {
        state.authNotificationStatus = "loading";
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.authNotificationStatus = "succeeded";
        state.authNotifications = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.authNotificationStatus = "failed";
        state.authNotificationError = action.payload;
      })

      .addCase(fetchPublicPosts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPublicPosts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(fetchPublicPosts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add post
      .addCase(savePost.fulfilled, (state) => {
        state.status = "idle";
      })

      // Update post
      .addCase(updatePost.fulfilled, (state) => {
        state.status = "idle";
      })

      .addCase(approvePost.fulfilled, (state) => {
        state.status = "idle";
      })
      // Delete post
      .addCase(deletePost.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default postsSlice.reducer;
